<template>
  <div class="scheduling-content">
    <div class="s-filter-box">
      <div class="b-left">
        <a-space>
          <a-input-search
            v-model:value="formBatchId"
            placeholder="Input Batch ID"
            @search="deleteBatch"
          >
            <template #enterButton>
              <a-button
                :loading="deleteBatchLoading"
                :disabled="!(getData.length && formBatchId)"
              >
                Batch Delete
              </a-button>
            </template>
          </a-input-search>

          <a-button @click="cancelSelect()">
            <span v-if="!isSelect">Select</span>
            <span v-else>Cancel Select</span>
          </a-button>
          <a-button @click="selectAll" :disabled="!isSelect">
            select All
          </a-button>
          <a-button
            type="danger"
            :loading="deleteLoading"
            @click="deleteSelect"
            :disabled="selectedTag.length === 0"
          >
            Delete
          </a-button>
        </a-space>
      </div>
      <div class="btn-right">
        <a-button type="link" @click="helpModalVis = true">Legend</a-button>
        <a-divider type="vertical" />
        <a-button type="link" :disabled="!getData.length" @click="doload()">
          Export
        </a-button>
        <a-divider type="vertical" />
        <a-button type="link" @click="loadLeveling">Refresh</a-button>
      </div>
    </div>
    <CardList
      ref="cardRef"
      :data-list="getData"
      :is-select="isSelect"
      page-name="leveling"
      :net-group="netGroup"
      :sort-name="searchColumnBy"
      save-text="Save Leveling"
      @onSelectChange="(v) => (selectedTag = v)"
      @dataUpdate="updateGetData"
      @onReqEndChange="reqEndChange"
      @onCancelLeveling="loadLeveling"
      @onSave="saveFn"
    ></CardList>
    <!-- 帮助信息 -->
    <LegendModal
      :isOpen="helpModalVis"
      @onModalClose="helpModalVis = false"
    ></LegendModal>
  </div>
</template>

<script setup>
  import request from '@/utils/request'
  import { ref, computed, watch } from 'vue'
  import { useStore } from 'vuex'
  import { message } from 'ant-design-vue'
  import dayjs from 'dayjs'
  import { baseURL } from '@/config'
  import LegendModal from './components/legend-modal.vue'
  import CardList from './components/card-list.vue'
  const store = useStore()

  const netGroup = computed(() => store.getters['user/currentNetGroup'])
  const currentSystem = computed(() => store.getters['user/currentSystem'])
  const searchColumnBy = 'reqEnd'
  const formBatchId = ref('')
  const selectedTag = ref([])
  const isSelect = ref(false)
  const cardRef = ref(null)
  const cancelSelect = () => {
    isSelect.value = !isSelect.value
  }
  const selectAll = () => {
    cardRef.value.selectAll()
  }

  // 下载
  const doload = () => {
    let url = `${baseURL}/api/schedule/downloadOrderMain?current-system=${currentSystem.value}&netGroupId=${netGroup.value}&status='leveled,created,onCall'`
    window.location.href = url
  }
  const deleteLoading = ref(false)
  const deleteSelect = function () {
    //删除选中
    deleteLoading.value = true
    var selectedTagObj = selectedTag.value.map((item) => {
      return { id: item.id }
    })

    request({
      url: '/api/scheduling/leveling/delRecords',
      method: 'post',
      nonstandard: true,
      data: {
        netGroupId: netGroup.value,
        loadTime: requestTime.value || 0,
        data: selectedTagObj,
      },
    })
      .then((res) => {
        if (res.errCode === '0000') {
          getData.value = getData.value.filter((item) => {
            return !selectedTagObj.some((m) => item.id === m.id)
          })
          message.success(res.body)
        } else {
          if (res.errCode == '1046') {
            //1046证明有人已经提交过修改需要重新加载
            message.warning(res.errMsg).then(() => {
              loadLeveling()
              isSelect.value = false
            })
          } else {
            message.error(res.errMsg)
          }
        }
      })
      .finally(() => {
        deleteLoading.value = false
      })
  }
  const deleteBatchLoading = ref(false)
  const deleteBatch = function () {
    //删除batchId

    if (formBatchId.value) {
      deleteBatchLoading.value = true
      //可以提交
      request({
        url: 'api/scheduling/leveling/delBatch',
        method: 'post',
        params: {
          netGroupId: netGroup.value,
          batchUploadId: formBatchId.value,
        },
      })
        .then(() => {
          loadLeveling()
          message.success('Delete Batch Success!')
          formBatchId.value = ''
        })
        .finally(() => {
          deleteBatchLoading.value = false
        })
    } else {
      message.warning('请填写正确的Batch ID！')
    }
  }
  const updateGetData = (list) => {
    getData.value = getData.value.map((item) => {
      const f = list.find((m) => m.id === item.id)
      if (f) {
        item = f
      }
      return item
    })
  }
  // 图例
  const helpModalVis = ref(false)

  // start 主体内容================================================
  const getData = ref([])
  const requestTime = ref(0)
  const loadLeveling = async () => {
    const hide = message.loading('Loading……', 0)

    try {
      const { body, errCode } = await request({
        url: '/api/scheduling/leveling',
        nonstandard: true,
        params: {
          netGroupId: netGroup.value,
        },
      })
      if (errCode === '0000') {
        getData.value = body.data
        requestTime.value = body.loadTime
      } else if (errCode === '1019') {
        loadLeveling()
      } else {
        getData.value = []
      }
      hide()
    } catch (e) {
      hide()
      getData.value = []
    }
  }
  loadLeveling()
  // 监控netGroupId
  watch(netGroup, loadLeveling)
  // reqEnd修改
  const reqEndChange = (pList) => {
    const hide = message.loading('Submitting', 0)
    const list = []
    pList.forEach((item) => {
      if (item.workOrders.length) {
        item.workOrders.forEach((m) => {
          list.push({
            id: m.id,
            reqEnd: dayjs(m.reqEnd2).valueOf(),
          })
        })
      }
    })
    request({
      url: '/api/scheduling/leveling/chgDate',
      method: 'post',
      data: {
        netGroupId: netGroup.value,
        loadTime: requestTime.value || 0,
        data: list || null,
      },
    })
      .then((res) => {
        getData.value = res.body.data
        requestTime.value = res.body.loadTime
      })
      .finally(() => {
        hide()
      })
  }
  const saveFn = (list) => {
    const hide = message.loading('Saving', 0)
    request({
      url: '/api/scheduling/leveling/save',
      method: 'post',
      nonstandard: true,
      data: {
        netGroupId: netGroup.value,
        loadTime: requestTime.value || 0,
        data: list || null,
      },
    })
      .then((res) => {
        if (res.errCode === '0000') {
          getData.value = res.body.data
          requestTime.value = res.body.loadTime
          message.success('Save Leveling Success!')
        } else {
          if (res.errCode == '1045') {
            //1045证明有人已经提交过修改需要重新加载
            message.warning(res.errMsg).then(() => {
              loadLeveling()
            })
          } else {
            message.error(res.errMsg || '未知错误')
          }
        }
      })
      .finally(() => {
        hide()
      })
  }
  // end 主体内容=========================================================
</script>

<style lang="less" scoped>
  @import './less/scheduling.less';
  .s-filter-box {
    padding: 10px;
    background: #f2f3f5;
    border-bottom: 1px solid #dbdcdc;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
</style>
